import React from 'react';
import ReactPaginate from 'react-paginate';


export default function Paginate({ initialPage, pages, onPageClick }) {
    return (
        <div className="card-footer py-4">
            <ReactPaginate
                previousLabel={<i className="fas fa-angle-left" />}
                nextLabel={<i className="fas fa-angle-right" />}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pages}
                initialPage={initialPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={onPageClick}
                pageClassName='page-item'
                pageLinkClassName='page-link'
                previousClassName='page-item'
                previousLinkClassName='page-link'
                nextClassName='page-item'
                nextLinkClassName='page-link'
                containerClassName={'pagination justify-content-end mb-0'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
            />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Pages/Items/Paginate.js